import axios from 'axios';
import config from './linkconfig.json'
import AsyncStorage from '@react-native-async-storage/async-storage';

const axiosBasicInstanceApiGateway = axios.create({
    baseURL: config.ApiLdapAuthentication,
    timeout: 2000,
    // headers: { 'X-Custom-Header': 'foobar' }
});

const refreshAccessToken = async () => {
    let sessionData = await AsyncStorage.getItem('sessionData')
    sessionData = JSON.parse(sessionData)
    // console.log("sessionData1");
    // console.log(sessionData);
    const refresh_token = sessionData["refresh_token"]
    console.log(refresh_token)
    await axios.post(config.ApiLdapAuthentication + "/refresh", {}, {
        headers: {
            Authorization: "Bearer " + refresh_token
        }
    })
        .then(async response => {
            // console.log(response)
            sessionData["access_token"] = response.data["access_token"]
            // console.log("sessionData2");
            // console.log(sessionData);
            await AsyncStorage.setItem("sessionData", JSON.stringify(sessionData))
            return (response.data["access_token"])
        })
        .catch(async error => {
            await AsyncStorage.removeItem("sessionData")
            console.log(error)
            // window.location.href = config.WebApp;
        })
}


const axiosTokenInstanceApiGateway = axios.create({
    baseURL: config.ApiLdapAuthentication,
    timeout: 2000,
    // headers: { 'X-Custom-Header': 'foobar' }
});

axiosTokenInstanceApiGateway.interceptors.response.use(async (response) => {
    // const access_token = await refreshAccessToken();
    return response;
}, async (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        console.log("Entrando")
        const access_token = await refreshAccessToken();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;
        return axiosTokenInstanceApiGateway(originalRequest);
    }
    if (error.response.status === 403) {
        // window.location.href = `${config.WebApp}forbidden`;
    }
    return Promise.reject(error);
})

axiosTokenInstanceApiGateway.interceptors.request.use(
    async configuration => {
        const value = await AsyncStorage.getItem('sessionData')
        const keys = JSON.parse(value)
        // console.log(configuration.headers);
        try {
            configuration.headers = {
                'Authorization': `Bearer ${keys.access_token}`,
                // 'Accept': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded'
            }
            return configuration;
        }
        catch (error) {
            console.log(error)
            // window.location.href = config.WebApp;
        }
    },
    error => {
        Promise.reject(error)
    });

// axiosTokenInstanceApiGateway.interceptors.response.use((response) => {
//     return response;
// }, (error) => {
//     toast.error(`Ocurrió un error con estado ${error.response.status}`, {
//         position: toast.POSITION.BOTTOM_RIGHT
//     })
//     return Promise.reject(error);
// })



export {
    axiosBasicInstanceApiGateway, axiosTokenInstanceApiGateway
}